<template>
	<div style="height: 450px;margin-top: 10px;" :id="divId"></div>
</template>
<script>
	export default {
		name: 'mapcontainer',
		props: {

		},
		data() {
			return {
				divId: Math.random(),
				map: null,
				geocoder: null,
				markers: null,
				pointId: '',
				editer:null,
				center: {
					height: 0,
					lat: 28.01469,
					lng: 120.65523
				}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.$nextTick(() => {
				this.init()
			})
		},
		computed: {

		},

		methods: {
			init() {
				const AK = "PLHBZ-5PZCJ-JOUFG-FBAUO-G5ZG6-HPBHA";
				const TMap_URL = "https://map.qq.com/api/gljs?v=1.exp&libraries=tools,service&key=" + AK +
					"&callback=onMapCallback";
				if (typeof window.TMap !== "undefined") {
					console.log('map123')
					this.onMapCallback()
					return
				}
				// 地图异步加载回调处理
				window.onMapCallback = this.onMapCallback

				// 插入script脚本
				let scriptNode = document.createElement("script")
				scriptNode.setAttribute("type", "text/javascript")
				scriptNode.setAttribute("src", TMap_URL)
				document.body.appendChild(scriptNode)
			},
			onMapCallback() {
				let center = new window.TMap.LatLng(this.center.lat, this.center.lng)
				let map = new window.TMap.Map(document.getElementById(this.divId), {
					center: center,
					zoom: 12,
				})
				this.geocoder = new window.TMap.service.Geocoder(); // 新建一个正逆地址解析类
				this.map = map
				this.pointId = 'markid_' + Math.random()
				this.markers = new window.TMap.MultiMarker({
					map: this.map,
					geometries: [],
					styles: {
						"highlight": new window.TMap.MarkerStyle({
							"src": "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker-pink.png"
						})
					},
				})
				this.editer = new window.TMap.tools.GeometryEditor({
					map: this.map, // 编辑器绑定的地图对象
					overlayList: [{
						overlay: this.markers, // 可编辑图层
						selectedStyleId: "highlight" // 被选中的marker会变为高亮样式
					}],
					actionMode: window.TMap.tools.constants.EDITOR_ACTION
						.INTERACT,
					selectable: true
				})
			},
			convert(address, type) {
				return new Promise((reslove, reject) => {
					this.geocoder.getLocation({
						address: address
					}).then((result) => {
						this.markers.updateGeometries([{
							id: this.pointId,
							position: result.result.location
						}])


						if (type == 'area') {
							this.center = result.result.location
							this.map.setCenter(result.result.location)
							this.map.zoomTo(12)
						} else {
							if (result.result.location.lat == this.center.lat && result.result.location
								.lng == this
								.center.lng) {
								this.map.setCenter(this.center)
								this.map.zoomTo(12)
								reject({
									message: '查询无结果'
								})
							} else {
								this.map.setCenter(result.result.location)
								this.map.zoomTo(16)
								reslove(result.result.location)

							}

						}

						//document.getElementById('location').value = result.result.location.toString()
					}, (result) => {
						reject(result)
						//console.log(result)
					})
				})
			},
			updateCenter(center){
				let position = new window.TMap.LatLng(Number(center.lat),Number(center.lng))
				this.map.setCenter(position)
				this.map.zoomTo(16)
				this.markers.updateGeometries([{
					id: this.pointId,
					position: position
				}])
			},
			getEditCenter() {
				return this.editer.getSelectedList()
			}
		},
		components: {

		}
	}
</script>
